import { render, staticRenderFns } from "./DocenteTutoriaPreasignacion.vue?vue&type=template&id=b4148f9e&"
import script from "./DocenteTutoriaPreasignacion.vue?vue&type=script&lang=js&"
export * from "./DocenteTutoriaPreasignacion.vue?vue&type=script&lang=js&"
import style0 from "./DocenteTutoriaPreasignacion.vue?vue&type=style&index=0&id=b4148f9e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports